module.exports = __webpack_public_path__ + "static/logo-60eccd0d40c09644d5067daebfea35e1.png";